import styled from "styled-components";

import theme from "config/theme";

export const Wrapper = styled.div`
  width: calc(100% - 40px);
  margin: -100px auto 100px;
  max-width: ${theme.size.maxWidth};
`;
